import { getSessionData } from 'utils/common.util';
import { useSelector } from 'react-redux';

export const useAccessibilityOptions = () => {
  const accessibility = useSelector((state) => state.accessibility);
  const accessibilitySession = getSessionData('accessibilityItems');

  const getAccessibilityState = (
    menuTheme,
    checked,
    itemId,
    underItemID = null,
  ) => {
    const fromMenu = accessibility?.accessibilityItems?.find(
      (menu) => menu.id == menuTheme,
    )?.items;
    const fromSession = accessibilitySession?.find(
      (menu) => menu.id == menuTheme,
    )?.items;

    const optionFromMenu = getAccessibilityOption(
      fromMenu,
      checked,
      itemId,
      underItemID,
    );
    const optionFromSession = getAccessibilityOption(
      fromSession,
      checked,
      itemId,
      underItemID,
    );

    const flag =
      accessibility?.accessibilityItems?.length > 0
        ? optionFromMenu
        : optionFromSession;

    return { optionFromMenu, optionFromSession, flag };
  };

  const getAccessibilityOption = (from, checked, itemId, underItemID) => {
    if (!from) return;
    let option = from?.find((item) => item.id == itemId);

    if (underItemID)
      option = option?.items?.find((item) => item.id == underItemID);

    if (checked)
      option = option?.items?.find(
        (radio) => radio.type == 'radio' && radio.isChecked,
      );
    else option = option.isToggle;

    return option;
  };

  const dyslexicState = getAccessibilityState('vision', false, 'dyslexicFont');
  const invertColorsState = getAccessibilityState(
    'vision',
    false,
    'invertColors',
  );
  const highContrastState = getAccessibilityState(
    'vision',
    false,
    'hightContrast',
  );
  const vocalAssistantState = getAccessibilityState(
    'audio',
    false,
    'assistantVocal',
    'activateAssistantVocal',
  );
  const voiceAssistantSpeedState = getAccessibilityState(
    'audio',
    true,
    'assistantVocal',
    'speechSpeed',
  );
  const voiceAssistantVoiceState = getAccessibilityState(
    'audio',
    true,
    'assistantVocal',
    'voiceOptions',
  );

  const SIZE = {
    normalFont: 'medium',
    smallFont: 'small',
    xsmallFont: 'xsmall',
  };
  const __fontState = getAccessibilityState(
    'vision',
    true,
    'fontSize',
    'fontSizeOptions',
  );
  const fontState = SIZE[__fontState.optionFromMenu?.id];
  const fontSessionState = SIZE[__fontState.optionFromSession?.id];
  const fontFlag =
    accessibility?.accessibilityItems?.length > 0
      ? fontState
      : fontSessionState;

  return {
    dyslexicState,
    highContrastState,
    invertColorsState,
    vocalAssistantState,
    voiceAssistantVoiceState,
    voiceAssistantSpeedState,
    fontFlag,
    fontState,
  };
};
export default useAccessibilityOptions;
